module.exports = __webpack_public_path__ + "img/summerHaze.c84c43d7.png";